module.exports = __webpack_public_path__ + "assets/images/Ativ.físicas.df509b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/icons/Ativ.físicas.png
// module id = 792
// module chunks = 1